import React, { useEffect } from "react";
import { Div, ScreenTitle, HeaderDiv, AroundHeaderIcons, HeaderIcons } from "../../styles/styles";
// import closeIcon from "../../images/close-icon.svg";
import NotificationsList from "./notificationList";
import { ensureNamespaces } from "../../i18n";
import { useTranslation } from "react-i18next";

const NotificationsSidebar = ({ onClose }) => {

  const { t } = useTranslation('account');      
  useEffect(() => { ensureNamespaces(['account']); }, []);
  

  return (
    <Div column justifyStart style={{ height: "100%" }}>
      {/* header панели */}
      <HeaderDiv padding="20px" deskHeight="auto">
        <AroundHeaderIcons onClick={onClose} width="30px" >
          <HeaderIcons backIcon  width="16px" />
        </AroundHeaderIcons>
        
          
        <ScreenTitle fontWeight="500">{t('notifications.title')}</ScreenTitle>

        <AroundHeaderIcons width="30px" />                  
        
      </HeaderDiv>
      

      {/* прокручиваемая часть */}
      <Div style={{ overflowY: "auto", height: "100%" }} justifyStart>
        <NotificationsList />
      </Div>
    </Div>
  );
};

export default NotificationsSidebar;
